import React from "react";
import styles from "./ReportSection.module.scss";

interface ReportSectionProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  icon?: React.ReactNode;
  padded?: boolean;
  className?: string;
  children: React.ReactNode;
}

/**
 * Başlıklı, aksiyonlu rapor bölüm kartı.
 * Rapor sayfalarında standart section kabı — chart, tablo, KPI grid vb. gömülebilir.
 */
const ReportSection: React.FC<ReportSectionProps> = ({
  title,
  description,
  actions,
  icon,
  padded = true,
  className = "",
  children,
}) => {
  return (
    <section className={`${styles.section} ${className}`}>
      <header className={styles.head}>
        <div className={styles.headLeft}>
          {icon && <span className={styles.icon}>{icon}</span>}
          <div className={styles.titleBlock}>
            <h3 className={styles.title}>{title}</h3>
            {description && (
              <p className={styles.description}>{description}</p>
            )}
          </div>
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </header>
      <div className={padded ? styles.bodyPadded : styles.body}>{children}</div>
    </section>
  );
};

export default ReportSection;
